var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('div',{staticClass:"clear"},[_c('el-image',{directives:[{name:"show",rawName:"v-show",value:(_vm.curData.src1),expression:"curData.src1"}],staticStyle:{"width":"100%"},attrs:{"src":_vm.curData.src1,"fit":"contain"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }